import {
  GeoJsonProperties,
  Geometry,
  LineString,
  MultiLineString,
  MultiPoint,
  MultiPolygon,
  Point,
  Polygon
} from "geojson";

import { CloseIcon, PinIcon, TargetIcon } from "@/assets/icons";
import { cn } from "@/lib/utils";

interface ComparePanelHeaderProps {
  value: GeoJsonProperties;
  isPinned: boolean;
  index: number;
  geometry:
    | Point
    | MultiPoint
    | LineString
    | MultiLineString
    | Polygon
    | MultiPolygon;
  attributeIdHeader: string;
  handlePinned: (index: number) => void;
  handleRemoveCurrentFeatureData: (index: number) => void;
  handleZoomToTarget: (geometry: Geometry) => void;
}

export default function ComparePanelHeader(
  props: Readonly<ComparePanelHeaderProps>
) {
  const {
    value,
    isPinned,
    index,
    geometry,
    attributeIdHeader,
    handlePinned,
    handleRemoveCurrentFeatureData,
    handleZoomToTarget
  } = props;

  return (
    <div className="h-[56px] flex flex-row items-center gap-2 justify-between">
      <h1
        className={cn(
          "text-sm flex flex-col font-semibold text-txtHeading leading-7 overflow-auto",
          isPinned && "text-teal-500"
        )}
      >
        <span className="text-left truncate hover:text-clip hover:overflow-auto">
          {attributeIdHeader}
        </span>
        {value?.Score && (
          <span className="text-xl truncate hover:text-clip hover:overflow-auto">
            Score: {value?.Score}
          </span>
        )}
      </h1>
      <div className="flex flex-row items-center gap-2">
        <button
          aria-label={isPinned ? "Unpin item" : "Pin item"}
          className={cn(
            "p-1 flex items-center justify-center rounded-md cursor-pointer",
            isPinned && "bg-teal-50"
          )}
          onClick={() => handlePinned(index)}
        >
          <PinIcon
            className={cn("fill-dim-gray size-5", isPinned && "fill-teal-500")}
          />
        </button>

        <button
          aria-label="Zoom to target"
          onClick={() => handleZoomToTarget(geometry)}
          className="flex items-center justify-center p-1 rounded-md cursor-pointer"
        >
          <TargetIcon className="fill-dim-gray size-5" />
        </button>
        <button
          aria-label="Remove item"
          disabled={isPinned}
          onClick={() => handleRemoveCurrentFeatureData(index)}
          className={cn(
            "p-1 flex items-center justify-center rounded-md cursor-pointer",
            isPinned && "cursor-not-allowed opacity-50"
          )}
        >
          <CloseIcon className="fill-dim-gray size-5" fill="#333" />
        </button>
      </div>
    </div>
  );
}
